// extracted by mini-css-extract-plugin
export default {"button":"Um-z","reviewSort":"Vm-z"};